import { c as _c } from "react/compiler-runtime";
import { NotFound } from "@repo/ui/components/NotFound";
import { createFileRoute } from "@tanstack/react-router";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/$")({
  component: NotFoundPage
});
function NotFoundPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(NotFound, {});
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}